import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NavigationExtras, Router } from '@angular/router';

export interface ErrorDialogData {
  title?: string;
  message: string;
  iconType: 'error' | 'warning' | 'info' | 'success';
  mainButtonText?: string;
  secondaryButtonText?: string;
  showSecondaryButton?: boolean;
  navRoute?: any[];
  navExtras?: NavigationExtras;
}

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {

  constructor(
    private _router: Router,
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ErrorDialogData,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.data.title = data.title || '¡Error!';
    this.data.message = data.message || 'NO_SPECIFIC_ERROR';
    this.data.mainButtonText = data.mainButtonText || 'GOT_TO_MAIN_VIEW';
    this.data.secondaryButtonText = data.secondaryButtonText || 'STAY_HERE';
    this.data.iconType = data.iconType || 'info';
    this.data.showSecondaryButton = data.showSecondaryButton ?? false;

    if (!this.data.showSecondaryButton) {
      this.data.mainButtonText = 'ACCEPT';
    } else {
      this.data.mainButtonText = data.mainButtonText || 'GOT_TO_MAIN_VIEW';
    }
  }

  async onConfirm(): Promise<void> {
    if (this.data.navRoute) {
      await this._router.navigate(this.data.navRoute, this.data.navExtras);
    }
    this.dialogRef.close(true);
  }

  onDismiss(bCloseReload: boolean = true): void {
    this.dialogRef.close(false);
    if (bCloseReload) {
      this.document.location.reload();
    }
  }
}
